<template>
  <v-form ref="form">
    <v-row class="pb-8">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          DADOS DA FATURA
        </p>
      </v-col>
      <v-col cols="12" sm="8" class="pr-sm-5">
        <BaseFormAutocomplete
          id-element="takerInvoice"
          placeholder="Inserir"
          v-model="form.tomador"
          :items="listTaker"
          hide-no-data
          item-text="nome_fantasia"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
          required
          :rules="[requiredInput]"
          label-text="Tomador Matriz/Filial"
          :template-taker="true"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <BaseFormAutocomplete
          id-element="documentNumberInvoice"
          placeholder="Inserir"
          v-model="form.tomador"
          :items="listTaker"
          hide-no-data
          item-text="cnpj"
          type="number"
          item-value="id"
          validate-on-blur
          @keyup="searchInput"
          :return-object="true"
          label-text="CNPJ"
          required
          :rules="[requiredInput]"
          :template-taker="true"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormSelect
          id-element="insuranceInvoice"
          placeholder="Inserir"
          v-model="form.seguradora"
          validate-on-blur
          :items="listInsuranceCompany"
          label-text="Seguradora"
          required
          :rules="[requiredInput]"
          item-text="nome"
          item-value="id"
          :return-object="true"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormInput
          id-element="numberInvoice"
          placeholder="Inserir"
          v-model="form.numero"
          validate-on-blur
          label-text="N° da Fatura"
          required
          :rules="[requiredInput]"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <BaseFormInput
          id-element="datEmissionInvoice"
          placeholder="DD/MM/AAAA"
          v-model="form.data_emissao"
          validate-on-blur
          label-text="Data Emissão"
          required
          :rules="[requiredInput, dateTermValid]"
          v-facade="maskDate"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormInput
          id-element="dateClosedInvoice"
          placeholder="DD/MM/AAAA"
          v-model="form.data_fechamento"
          validate-on-blur
          label-text="Fechamento da Fatura"
          required
          :rules="[requiredInput, dateTermValid]"
          v-facade="maskDate"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4" class="pr-sm-5">
        <BaseFormInput
          id-element="deadlineInvoice"
          placeholder="DD/MM/AAAA"
          v-model="form.data_vencimento"
          validate-on-blur
          label-text="Vencimento"
          required
          :rules="[requiredInput, dateTermValid]"
          v-facade="maskDate"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <BaseMoney
          id-element="bonusFinancialData"
          placeholder="R$ 1.000,00"
          v-model="form.valor"
          required
          :rules="[requiredInput]"
          label-text="Valor Total"
          :disabled="disabledEdit"
        />
      </v-col>
      <v-col cols="12">
        <v-divider />
      </v-col>
    </v-row>
    <v-row v-if="isEdit">
      <v-col cols="12" sm="4" class="mb-5">
        <BaseButton
          v-html="'INATIVAR FATURA'"
          class="pink white--text"
          width="100%"
          @click="$emit('inactivate')"
          :disabled="disabledEdit"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="primary--text form__title mb-3">
          DOCUMENTOS
        </p>
      </v-col>
      <v-col cols="12" sm="6" class="pr-sm-5">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Anexar Documento
        </p>
        <DropFile
          @selected-files="addFilesDocuments"
          :multiple="false"
          class="mb-5"
          v-if="!hasDocuments"
        />
        <DocumentDataTable
          v-else
          :documents="[form.arquivo]"
          :delete-button="!disabledEdit"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFileDocuments"
        />
        <BaseErrorMessages
          v-if="errorMessages.length > 0"
          :error-messages="errorMessages"
        />
      </v-col>
      <v-col cols="12" sm="6">
        <p class="body-2 font-weight-bold primary--text mb-2">
          Anexar Boleto
        </p>
        <DropFile
          @selected-files="addFilesBills"
          :multiple="true"
          class="mb-5"
        />
        <DocumentDataTable
          v-if="hasBills"
          :documents="form.boletos"
          :delete-button="!disabledEdit"
          @preview-file="onPreviewFile"
          @remove-file="onRemoveFileBills"
        />
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" xl="2" class="pr-sm-5">
          <BaseButton
            v-html="'VOLTAR'"
            class="white--text secondary"
            width="100%"
            @click="$emit('cancel')"
            v-if="disabledEdit"
          />
          <BaseButton
            v-html="'CANCELAR'"
            class="pink white--text"
            width="100%"
            @click="$emit('cancel')"
            v-else
          />
        </v-col>
        <v-col cols="12" sm="5" md="3" xl="2">
          <BaseButton
            v-html="nameButton"
            class="secondary"
            width="100%"
            @click="submit"
            :disabled="disabledEdit"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import { FILE } from "@/mixins/DocumentsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTable from "@/components/DocumentDataTable";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import DropFile from "@/components/DropFile";
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    errorMessages: [],
    requiredInput,
    dateTermValid,
    maskDate,
    timeout: null
  }),
  components: {
    DocumentDataTable,
    DropFile
  },
  mixins: [LoadingRequest, DocumentsMixin],
  computed: {
    ...mapState("policy", ["listTaker", "listInsuranceCompany"]),
    hasDocuments() {
      return this.form.arquivo;
    },
    hasBills() {
      return this.form.boletos && this.form.boletos.length > 0;
    }
  },
  methods: {
    ...mapActions("policy", ["requestListTaker"]),
    searchInput(value) {
      clearTimeout(this.timeout);
      let vm = this;
      // fazer requisição apenas se tiver valor no input
      if (value.target.value.length >= 3)
        this.timeout = setTimeout(function() {
          const payload =
            value.target.id == "documentNumberInvoice"
              ? `?query=${value.target.value.replace(/[^0-9]/g, "")} `
              : `?query=${value.target.value}`;
          vm.fetchTaker(payload);
          vm.timeout = null;
        }, 500);
    },
    fetchTaker(payload) {
      this.withLoading(this.requestListTaker(payload));
    },
    submit() {
      if (this.validate()) this.$emit("submit", this.form);
    },
    validate() {
      this.errorMessages = this.hasDocuments
        ? []
        : ["É preciso adicionar um documento"];
      return this.$refs.form.validate() && this.hasDocuments;
    },
    addFilesBills(files) {
      this.form.boletos = this.form.boletos.concat(
        files.map(file => ({
          arquivo: {
            [FILE]: file,
            nome: file.name
          }
        }))
      );
    },
    onRemoveFileBills(item) {
      this.form.boletos = this.form.boletos.filter(document => {
        return item.arquivo
          ? item.arquivo.nome !== document.arquivo.nome
          : document.nome !== item.nome;
      });
    },
    addFilesDocuments(files) {
      this.form.documentos = files.map(file => ({
        arquivo: {
          [FILE]: file,
          nome: file.name
        }
      }));
      this.form.arquivo =
        this.form.documentos[0].arquivo || this.form.documentos[0];
    },
    onRemoveFileDocuments() {
      this.form.arquivo = null;
    }
  },
  props: {
    form: {
      type: Object
    },
    nameButton: {
      type: String,
      default: "GERAR FATURA"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    disabledEdit: {
      type: Boolean,
      default: false
    }
  }
};
</script>
